// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"301":"90134377","474":"c25de387","970":"8d9976dc"}[chunkId] + ".css";
};